import type { IStockRepository } from '@/features/stock/domain/repositories/IStockRepository.js';
import type { StockTransactionItemEntity } from '@/features/stock/domain/entities/StockEntity.js';

interface Deps { stockRepository: IStockRepository; }

export function createListTransactionItemsUseCase({ stockRepository }: Deps) {
  return async function listTransactionItems(transactionId: string): Promise<StockTransactionItemEntity[]> {
    return stockRepository.listTransactionItems(transactionId);
  };
}
